/**
 * Public "Contact Us" API client.
 *
 * Posts the contact form to the no-auth endpoint:
 *   POST {BASE}/api/v1/contact/public/:orgSlug
 * which emails the submission to the org inbox (saharicourier@gmail.com).
 * Same BASE/org-slug convention as the Book Shipment enquiry client.
 */

const BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:4000';
const ORG_SLUG = process.env.REACT_APP_ORG_SLUG ?? 'sahari-cargo';

export type ContactPayload = {
  name: string;
  email: string;
  phone?: string;
  message: string;
};

export async function submitContact(
  p: ContactPayload,
  captchaToken?: string | null,
): Promise<void> {
  const body: Record<string, unknown> = {
    name: p.name.trim(),
    email: p.email.trim(),
    ...(p.phone?.trim() ? { phone: p.phone.trim() } : {}),
    message: p.message.trim(),
  };

  let res: Response;
  try {
    res = await fetch(`${BASE}/api/v1/contact/public/${ORG_SLUG}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(captchaToken ? { 'cf-turnstile-response': captchaToken } : {}),
      },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error(
      'Could not reach the server. Please check your connection and try again.',
    );
  }

  if (!res.ok) {
    let message = 'Could not send your message. Please try again.';
    try {
      const j = await res.json();
      const m = j?.message ?? j?.error;
      if (typeof m === 'string') message = m;
      else if (Array.isArray(m) && m.length) message = m[0];
    } catch {
      /* keep default */
    }
    throw new Error(message);
  }
}
